module.exports = __webpack_public_path__ + "media/images/strava-badge-alt-35d24336.svg";